<template>
      <div class="box">
        <h4>导入数据-学生档案</h4>
        <el-table :data="tableData" border empty-text="暂无数据" style="width: 100%">
            <el-table-column type="index" :label="'序号'" width="50" align="center"> </el-table-column>
            <el-table-column prop="rowIndex" :label="'列数'" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="errorMessage" :label="'导入说明'" align="center" :show-overflow-tooltip="true">
            </el-table-column>
        </el-table>
      </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function(e) {
        let data = JSON.parse(this.$route.query.data)
        this.tableData = data
    },
    methods: {
    }
}
</script>

<style scoped>
.box {
    height: 100%;
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
table {
    border-collapse: collapse; /* 合并边框 */
    width: 100%;
  }
  table, th, td {
    border: 1px solid black; /* 设置边框 */
  }
</style>

